import { useSplitTestBranch } from '@api/lendingAPI/lapiHooks';
import { getCountry } from '@iwIntlProvider/CountryProvider';

const DE_6M_BS_TEST_NAME = 'de_6m_pdf_bs_test_2026_q2';

export const useIsInSixMonthBsTest = () => {
    const isDE = getCountry() === 'DE';

    const { branch } = useSplitTestBranch({
        test: DE_6M_BS_TEST_NAME,
        suspense: true,
        enabled: isDE
    });

    return branch === 'INCLUDE';
};
